import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Tap-friendly contextual help (§F): unobtrusive info affordance, plain-English
// explanation on click/tap — works on desktop and mobile (no hover dependency).
export function HelpTip({ text, testid }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="More information"
          data-testid={testid}
          className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-limestone text-warmgrey transition-colors duration-150 hover:border-terracotta hover:text-terracotta"
        >
          <Info className="h-3 w-3" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-72 border-border bg-white text-sm leading-relaxed text-charcoal"
        data-testid={testid ? `${testid}-content` : undefined}
      >
        {text}
      </PopoverContent>
    </Popover>
  );
}
